import * as t from "io-ts";
import { isRight } from "fp-ts/lib/Either";

import { iconImageCodec } from "../components/SerializedApp";
import { appAnalyticsCodec, AuthenticationMethod } from ".";
import { pricingCodec } from "./pricing";
import { DocumentData } from "./core";

export const tileDescriptionCodec = t.intersection([
    t.type({
        title: t.string,
        primaryAccentColor: t.string,
        authenticationKind: t.union([
            t.literal(AuthenticationMethod.None),
            t.literal(AuthenticationMethod.Password),
            t.literal(AuthenticationMethod.PublicEmailPin),
            t.literal(AuthenticationMethod.WhitelistEmailPin),
            t.literal(AuthenticationMethod.OrgMembers),
            t.literal(AuthenticationMethod.JustMe),
            t.literal(AuthenticationMethod.UserProfileEmailPin),
        ]),
        url: t.string,
    }),
    t.partial({
        description: t.string,
        iconImage: iconImageCodec,
        isSample: t.boolean,
        isFavorite: t.boolean,
        // FIXME: If the author updates their "business name", we need
        // to update this.
        sampleAuthor: t.string,
        sampleAuthorEmail: t.string,
        categories: t.array(t.string),
        samplePricing: pricingCodec,
        purchases: t.number,
        copies: t.number,
        analytics: appAnalyticsCodec,
        requiresSheetReconnect: t.boolean,
        // FIXME: Make this required once we have it everywhere
        userID: t.string,
        // We just need these `authIDs` so that the Firestore permission rules
        // work.  FIXME: Make this required once we have it everywhere
        authIDs: t.readonlyArray(t.string),
        // FIXME: Expose lastCopiedAt as a value here
    }),
]);

export type TileDescription = t.TypeOf<typeof tileDescriptionCodec>;

export function isTileDescription(x: DocumentData | undefined): x is TileDescription {
    if (x === undefined) return false;
    return isRight(tileDescriptionCodec.decode(x));
}
